
import { useCurrentUser } from "services/currentUserService.js";



export const enum CaseAccessRights {
    ModifyClient = "case.ModifyClient",
    ModifyMatter = "case.ModifyMatter",
    Onboarding = "case.Onboarding",
    Compliance = "case.Compliance",
    OpenMatter = "case.OpenMatter",
    DeleteTasks = "case.DeleteTasks",
    DeleteChits = "case.DeleteChits",
    ViewContact = "case.ViewContact",
    ModifyContact = "case.ModifyContact",
    AllBranches = "case.AllBranches",
    AllTeams = "case.AllTeams",
    AllFeeEarners = "case.AllFeeEarners",
    DashboardStats = "case.DashboardStats",
    EditWorkFlow = "case.EditWorkFlow",
}

export const enum AccountsAccessRights {
    ViewMatterLedger = "accounts.ViewMatterLedger",    
    AddBills = "accounts.AddBills",
    OfficePostings = "accounts.OfficePostings",
    OfficeAllocations = "accounts.OfficeAllocations",
    ClientPostings = "accounts.ClientPostings",
    TransferPostings = "accounts.TransferPostings",
    BatchPostings = "accounts.BatchPostings",
    ModifyNominals = "accounts.ModifyNominals",
    NominalLedger = "accounts.NominalLedger",
    BankPostings = "accounts.BankPostings",
    JournalPostings = "accounts.JournalPostings",
    VATReturn = "accounts.VATReturn",
    BankRec = "accounts.BankRec",
    ModifySuppliers = "accounts.ModifySuppliers",
    SupplierLedger = "accounts.SupplierLedger",
    PurchaseInvoice = "accounts.PurchaseInvoice",
    Disbursement = "accounts.Disbursement",
    PayDisbursement = "accounts.PayDisbursement",
    PaySupplier = "accounts.PaySupplier",
    EditPosting = "accounts.EditPosting",
    AccountsAdmin = "accounts.AccountsAdmin",
    AuthorizationLevel1 = "accounts.AuthorizationLevel1",
    AuthorizationLevel2 = "accounts.AuthorizationLevel2",
    AuthorizationLevel3 = "accounts.AuthorizationLevel3",
}

export const enum ReportsAccessRights {
    ClientListing = "reports.ClientListing",
    MatterBalances = "reports.MatterBalances",
    Disbursements = "reports.Disbursements",
    Billing = "reports.Billing",
    SupplierBalance = "reports.SupplierBalance",
    NominalBalance = "reports.NominalBalance",
    BankRec = "reports.BankRec",
}


export type AccessRight = CaseAccessRights | AccountsAccessRights | ReportsAccessRights;


export function useAccessRight(right: AccessRight): boolean {

    const user = useCurrentUser();

    if (!right.includes(".")) {
        return false;
    }

    const [section, permission] = right.split(".");
    return user?.data?.profile?.[section]?.[permission] === true;
}


export function useAccessRightChecker(): (right: AccessRight) => boolean {
    const user = useCurrentUser();
    return (right: AccessRight) => {

        if (!right.includes(".")) {
            return false;
        }

        const [section, permission] = right.split(".");
        return user?.data?.profile?.[section]?.[permission] === true;
    };
}




